import { API_URL } from "../config";
import { isPublicPath, getCleanPath } from "./publicPaths";
import { isSessionAcknowledged } from "./sessionGate";
import { clearSessionKeys } from "./sessionKeys";

/**
 * Clears client session markers and invalidates the httpOnly auth cookie on the server.
 */
export async function revokeUnacknowledgedServerSession(options = {}) {
  try {
    await fetch(`${API_URL}/logout`, {
      method: "POST",
      credentials: "include",
    });
  } catch {
    /* network errors must not block local cleanup */
  }
  clearSessionKeys(options);
}

/**
 * @param {string} pathname
 * @param {string} [search]
 * @returns {string | null}
 */
export function buildLoginRedirectTarget(pathname, search = "") {
  const cleanPath = getCleanPath(pathname);
  if (isPublicPath(cleanPath) || cleanPath === "/login") {
    return null;
  }
  const returnPath = `${pathname}${search || ""}`;
  return `/login?redirect=${encodeURIComponent(returnPath)}`;
}

/**
 * Forces login when the browser tab has no acknowledged session (e.g. after browser restart).
 *
 * @param {string} pathname
 * @param {string} [search]
 * @returns {Promise<{ forceLogin: boolean, redirectTo: string | null }>}
 */
export async function enforceBrowserSessionGate(pathname, search = "") {
  if (isSessionAcknowledged()) {
    return { forceLogin: false, redirectTo: null };
  }

  const redirectTo = buildLoginRedirectTarget(pathname, search);
  if (!redirectTo) {
    return { forceLogin: false, redirectTo: null };
  }

  await revokeUnacknowledgedServerSession();
  return { forceLogin: true, redirectTo };
}
